import RequestScheduleList from '@src/components/schedule/request-list';

export default function RequestList() {
  return <RequestScheduleList />;
}
